<template>
    <div :class="['modal', isActive ? 'active' : '', customClasses]">
        <div v-if="isActive" class="modal__overlay" @click="closeModal"></div>
        <!-- /.modal__overlay -->

        <div v-if="isActive" class="modal__inner" ref="modalContent">
            <button v-if="!hideCloseButton"  type="button" class="modal__close" @click="closeModal">
                x
            </button>

            <div class="modal__content">
                <slot :close-modal="closeModal" />
            </div>
            <!-- /.modal__content -->
        </div>
        <!-- /.modal__inner -->
    </div>
    <!-- /.modal -->
</template>

<script>
/**
 * Internal dependencies.
 */
import { ref, computed, onUnmounted } from 'vue';

export default {
    /**
     * Component name.
     *
     * @type {String}
     */
    name: 'Modal',

    /**
     * Default Data
     */
    data: () => ({
        isActive: false,
    }),

    /**
     * The passed properties.
     *
     * @type {Object}
     */
    props: {
        customClasses: {
            type: String,
            default: '',
        },
        hideCloseButton: {
            type: Boolean,
            default: false,
        },
        defaultActive: {
            type: Boolean,
            default: false
        },
    },

    setup(props, {emit}) {
        const isActive = ref(props.defaultActive);

        const closeModal = () => {
            isActive.value = false;

            emit('on-modal-close')
        };

        const handleEscKeyModalClose = evt => {
            if (evt.keyCode === 27) {
                isActive.value = false;
                emit('on-modal-close');
            }
        };

        document.addEventListener('keyup', handleEscKeyModalClose);

        onUnmounted(() => {
            document.removeEventListener('keyup', handleEscKeyModalClose);
        })

        return {
            isActive: computed(() => isActive.value),
            closeModal
        }
    }
};
</script>
